/* ========================================
   DAYS THEME: NAVEGAÇÃO DO PRODUTO
   Botão voltar na página de produto
   ======================================== */

class DaysProductNavigation {
  constructor() {
    this.backButton = document.getElementById('yeezy-back-btn');

    if (!this.backButton) {
      return;
    }

    this.init();
  }

  init() {
    // Adicionar evento de click no botão voltar
    this.backButton.addEventListener('click', () => {
      this.handleBackNavigation();
    });
  }

  handleBackNavigation() {
    // Verificar se há histórico de navegação
    if (window.history.length > 1 && document.referrer) {
      // Verificar se veio de uma página do mesmo domínio
      const referrer = new URL(document.referrer);
      const currentDomain = window.location.hostname;

      if (referrer.hostname === currentDomain) {
        // Voltar para a página anterior
        window.history.back();
      } else {
        // Se veio de fora, ir para a home ou collections
        this.goToDefaultPage();
      }
    } else {
      // Se não há histórico, ir para página padrão
      this.goToDefaultPage();
    }
  }

  goToDefaultPage() {
    // Tentar ir para /collections/all, senão vai para a home
    const collectionsUrl = '/collections/all';
    const homeUrl = '/';

    // Verificar se a página referrer contém "collection"
    if (document.referrer && document.referrer.includes('/collections/')) {
      window.location.href = document.referrer;
    } else {
      window.location.href = collectionsUrl;
    }
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DaysProductNavigation();
  });
} else {
  new DaysProductNavigation();
}
